import { render, staticRenderFns } from "./IndexMenu.vue?vue&type=template&id=4fb5e633&scoped=true&"
import script from "./IndexMenu.vue?vue&type=script&lang=js&"
export * from "./IndexMenu.vue?vue&type=script&lang=js&"
import style0 from "./IndexMenu.vue?vue&type=style&index=0&id=4fb5e633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb5e633",
  null
  
)

export default component.exports